(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[810],{

/***/ 6937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index_card",
      function () {
        return __webpack_require__(4223);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_card; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./src/ui/components/LocationInfo/index.tsx + 1 modules
var LocationInfo = __webpack_require__(5119);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
;// CONCATENATED MODULE: ./public/images/indexCard.svg
var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgIndexCard = function SvgIndexCard(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 564 306"
  }, props), /*#__PURE__*/react.createElement("g", {
    style: {
      isolation: "isolate",
      fontSize: 12,
      fontFamily: "ArialMT,Arial"
    }
  }, _text || (_text = /*#__PURE__*/react.createElement("text", {
    transform: "translate(40 31)"
  }, "Aufkl\xE4rung: Revista de Filosofia / Universidade Federal da Para\xEDba,")), _text2 || (_text2 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 46)"
  }, "GP Teoria Cr\xEDtica e Hermen\xEAutica/UFPB/CNPq, Atividades Associadas -")), _text3 || (_text3 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 61)"
  }, "v.4. n.1. (2017) - Jo\xE3o Pessoa: GP Teoria Cr\xEDtica e Hermen\xEAutica")), _text4 || (_text4 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 76)"
  }, "/UFPB/CNPq, 2017 - v.")), _text5 || (_text5 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 136)"
  }, "Quadrimestral. 2017")), _text6 || (_text6 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 151)"
  }, "Semestral. 2016")), _text7 || (_text7 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 166)"
  }, "ISSN: 2318-9428 Online")), _text8 || (_text8 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 181)"
  }, "ISSN: 2358-8470 Impresso")), _text9 || (_text9 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(60 196)"
  }, "DOI: 10.18012/ARF")), _text10 || (_text10 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(40 241)"
  }, "1.Filosofia, Pesquisa filos\xF3fica - Peri\xF3dicos. 2.Filosofia geral - Peri\xF3dicos. I. GP Teoria")), _text11 || (_text11 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(40 256)"
  }, "Cr\xEDtica e Hermen\xEAutica/UFPB/CNPq. Atividades Associadas.")), _text12 || (_text12 = /*#__PURE__*/react.createElement("text", {
    transform: "translate(317 286)"
  }, "CDD 105"))), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    },
    d: "M1 1v304h562V1z"
  }));
};

/* harmony default export */ var indexCard = (SvgIndexCard);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/index_card/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n display: flex;\n align-items: center;\n padding: 4vh 0 2vh;\n border-top: 1px solid #ddd;\n flex-direction: column;\n\n svg {\n  width: 70%;\n  margin-bottom: 1vh;\n\n  @media (max-width: 426px) {\n   width: 170%;\n   transform: rotate(90deg);\n   margin: 10vh 0 13vh;\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-da1e94ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/pages/index_card/index.tsx






var description = 'Ficha contendo os dados bibliogr\xe1ficos da Revista Aufkl\xe4rung.';
var title = 'Ficha Catalogr\xe1fica';
var IndexCard = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInfo/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(indexCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/images/indexCard.png",
                        children: "Deseja baixar uma c\xf3pia?"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var index_card = (IndexCard);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(6937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);